<template>
  <div class="xb-verification-code">
    <canvas id="xb-verification-code" :width="contentWidth" :height="contentHeight"></canvas>
  </div>
</template>
<script>
export default {
	name: 'verificationCode',
	props: {
		identifyCode: {
			// 默认注册码
			type: String,
			default: '1234'
		},
		fontSizeMin: {
			// 字体最小值
			type: Number,
			default: 18
		},
		fontSizeMax: {
			// 字体最大值
			type: Number,
			default: 40
		},
		backgroundColorMin: {
			// 背景色最小值
			type: Number,
			default: 180
		},
		backgroundColorMax: {
			// 背景色最大值
			type: Number,
			default: 240
		},
		colorMin: {
			// 字体颜色最小值
			type: Number,
			default: 50
		},
		colorMax: {
			// 字体颜色最大值
			type: Number,
			default: 160
		},
		lineColorMin: {
			// 干扰线颜色最小值
			type: Number,
			default: 40
		},
		lineColorMax: {
			// 干扰线颜色最大值
			type: Number,
			default: 180
		},
		dotColorMin: {
			// 干扰点颜色最小值
			type: Number,
			default: 0
		},
		dotColorMax: {
			// 干扰点颜色最大值
			type: Number,
			default: 255
		},
		contentWidth: {
			// 容器宽度
			type: Number,
			default: 85
		},
		contentHeight: {
			// 容器高度
			type: Number,
			default: 36
		}
	},
	methods: {
		// 生成一个随机数
		randomNum(min, max) {
			return Math.floor(Math.random() * (max - min) + min);
		},
		// 生成一个随机的颜色
		randomColor(min, max) {
			let r = this.randomNum(min, max);
			let g = this.randomNum(min, max);
			let b = this.randomNum(min, max);
			return 'rgb(' + r + ',' + g + ',' + b + ')';
		},
		// 绘制图形码图片
		drawPic() {
			let canvas = document.getElementById('xb-verification-code');
			let ctx = canvas.getContext('2d');
			ctx.textBaseline = 'bottom';
			// 绘制背景
			ctx.fillStyle = this.randomColor(
				this.backgroundColorMin,
				this.backgroundColorMax
			);
			ctx.fillRect(0, 0, this.contentWidth, this.contentHeight);
			// 绘制文字
			for (let i = 0; i < this.identifyCode.length; i++) {
				this.drawText(ctx, this.identifyCode[i], i);
			}
			// this.drawLine(ctx); // 绘制干扰线
			// this.drawDot(ctx) // 绘制干扰点
		},
		// 绘制文本
		drawText(ctx, txt, i) {
			ctx.fillStyle = this.randomColor(this.colorMin, this.colorMax);
			ctx.font =
				this.randomNum(this.fontSizeMin, this.fontSizeMax) + 'px SimHei';
			let x = (i + 1) * (this.contentWidth / (this.identifyCode.length + 1));
			let y = this.randomNum(this.fontSizeMax, this.contentHeight - 5);
			var deg = this.randomNum(-30, 30); // 字符旋转角度(不超过45度比较好)
			// 修改坐标原点和旋转角度
			ctx.translate(x, y);
			ctx.rotate((deg * Math.PI) / 180);
			ctx.fillText(txt, 0, 0);
			// 恢复坐标原点和旋转角度
			ctx.rotate((-deg * Math.PI) / 180);
			ctx.translate(-x, -y);
		},
		// 绘制干扰线
		drawLine(ctx) {
			for (let i = 0; i < 8; i++) {
				ctx.strokeStyle = this.randomColor(
					this.lineColorMin,
					this.lineColorMax
				);
				ctx.beginPath();
				ctx.moveTo(
					this.randomNum(0, this.contentWidth),
					this.randomNum(0, this.contentHeight)
				);
				ctx.lineTo(
					this.randomNum(0, this.contentWidth),
					this.randomNum(0, this.contentHeight)
				);
				ctx.stroke();
			}
		},
		// 绘制干扰点
		drawDot(ctx) {
			for (let i = 0; i < 100; i++) {
				ctx.fillStyle = this.randomColor(0, 255);
				ctx.beginPath();
				ctx.arc(
					this.randomNum(0, this.contentWidth),
					this.randomNum(0, this.contentHeight),
					1,
					0,
					2 * Math.PI
				);
				ctx.fill();
			}
		}
	},
	watch: {
		identifyCode() {
			this.drawPic();
		}
	},
	mounted() {
		this.drawPic();
	}
};
</script>
